import { useQueries } from "@tanstack/react-query";
import type { ThreadLimits } from "@/features/thread/utils/threadExpiry";
import { apiGet } from "@/shared/api";

export const BOARD_R18_THREAD_CREATION_ALLOWED_QUERY_KEY = [
  "board-r18-thread-creation-allowed",
] as const;

/** Board R18表示専用のquery key。thread作成用thread-limits cacheとは共有しない。 */
export function boardR18ThreadCreationAllowedQueryKey(
  slug: string,
): readonly ["board-r18-thread-creation-allowed", string] {
  return [...BOARD_R18_THREAD_CREATION_ALLOWED_QUERY_KEY, slug];
}

/** 候補板ごとのR18 thread作成許可を取得する。取得中・取得失敗はfalseとして扱う。 */
export function useBoardR18ThreadCreationAllowed(
  slugs: readonly string[],
): Readonly<Record<string, boolean>> {
  const queries = useQueries({
    queries: slugs.map((slug) => ({
      queryKey: boardR18ThreadCreationAllowedQueryKey(slug),
      queryFn: async (): Promise<boolean> => {
        const limits = await apiGet<ThreadLimits>(
          `/thread-limits/${encodeURIComponent(slug)}`,
          { cache: "no-store", boardKey: slug },
        );
        return limits.allowR18ThreadCreation === true;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: "always" as const,
      refetchInterval: false,
    })),
  });

  return Object.fromEntries(
    slugs.map((slug, index) => {
      const query = queries[index];
      return [slug, query?.isError !== true && query?.data === true];
    }),
  );
}
